import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'ea-parrainage',
    templateUrl: './ea-parrainage.component.html',
    styleUrls: ['./ea-parrainage.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EaParrainageComponent {
  constructor(private router: Router) {}

  goToParrainages() {
    this.router.navigate(['dashboard/parrainages']);
  }
}
